import { FC, PropsWithChildren } from 'react';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';

const StepFormSubtitle: FC<PropsWithChildren<PropsWithClassName>> = ({ children, className }) => (
  <p className={cn('font-dm text-sm text-[rgba(0,0,0,0.6)] leading-[150%] tracking-[0.15px]', className)}>{children}</p>
);

export default StepFormSubtitle;
